
import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export const PlanRecipientInfoComponent = ({
  choosenEmailPlan, customerTags,
  handleInnerFormChange,
  isEmail
}: any) => {

  return (
    <>
      {isEmail && <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
          label="Reply To"
          labelField="Reply To"
          onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(
              event.target.value,
              'ReplyToEmailInclusions',
            );
          }}
          type="text"
          value={choosenEmailPlan?.ReplyToEmailInclusions}
        />

        <InputContainer
          label="Recipient"
          labelField="Name"
          list={customerTags}
          onValueChange={(newValue: any) => {
            const categoryData: any = newValue.map((option: any) => option?.value || '')
            handleInnerFormChange(
              categoryData,
              'RecipientTagIdInclusions',
            );
          }}
          type="multiselect"
          valueField="ValueId"
          value={choosenEmailPlan?.RecipientTagIdInclusions}
        />

        <InputContainer
          label="CC"
          labelField="Name"
          list={customerTags}
          onValueChange={(newValue: any) => {
            const categoryData: any = newValue.map((option: any) => option?.value || '')
            handleInnerFormChange(
              categoryData,
              'CCTagIdInclusions',
            );
          }}
          type="multiselect"
          valueField="ValueId"
          value={choosenEmailPlan?.CCTagIdInclusions}
        />

        <InputContainer
          label="BCC"
          labelField="Name"
          list={customerTags}
          onValueChange={(newValue: any) => {
            const categoryData: any = newValue.map((option: any) => option?.value || '')
            handleInnerFormChange(
              categoryData,
              'BCCTagIdInclusions',
            );
          }}
          type="multiselect"
          valueField="ValueId"
          value={choosenEmailPlan?.BCCTagIdInclusions}
        />
      </div>}    
    </>
  );
};
export default PlanRecipientInfoComponent;
